module.exports = __webpack_public_path__ + "static/media/shop-category-voucher.ec71048f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/shop-category-voucher.svg
// module id = 199
// module chunks = 0